define('modules/footer/footer_view',[
  'backbone',
  'jquery',
  '_',

  'text!./footer_template.html',

  'session'
], function (Backbone, $, _,
             footer_template,
             session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();


    },

    template: _.template(footer_template),

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    remove: function () {
      this.$el.empty();
      this.stopListening();
      this.$el.off();
      return this;
    }
  });
  return View;
});

